export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Reset Password',
        resetPasswordMessage: 'To have your password reset, enter your email address below. We will then send an email containing a link to reset your password.',
        emailLabel: 'Email Address',
        sendEmailButton: 'Send Email',
        stillHavingTroublesMsg: 'Still having trouble?',
        unableResetPasswordMessage: 'If you’re unable to reset your password, please call Customer Service at',
        sephoraPhoneNumber: '1-877-SEPHORA',
        phoneNumberTTY: '(1-877-737-4672)',
        phoneNumber: '1-888-866-9845',
        forAssistanceMessage: 'Deaf and Hard-of-Hearing/TTY see',
        accessibility: 'Accessibility',
        resetPassword: 'Reset Password',
        confirmationMessage: 'We have sent an email to',
        confirmationMessage2: 'Please check your inbox and click on the link to reset your password.',
        confirmButton: 'OK',
        fallbackErrorMsg: 'If you are unable to reset your password, please call Customer Service for assistance.',
        fallbackPasskeyErrorMsg: 'If you are unable to reset your passkey, please call Customer Service for assistance.',
        forgotYourPasswordTitle: 'Forgot your password?',
        passkeysIntroMessage: 'Sephora is switching to passkeys. Switch to fingerprint, PIN, or device password for a faster and safer sign in. We never receive your biometric data like fingerprints or face scans.',
        verifyEmailMessage: 'Enter your email address below to verify your account.',
        sharedDeviceDisclaimer: 'Not advised for shared devices.',
        termsAndConditions: 'By clicking "Continue", you (1) agree to the current version of our ',
        termsOfUse: 'TERMS OF USE',
        termsAndConditionsRest: ', and (2) have read Sephora\'s ',
        privacyPolicy: 'Privacy Policy',
        resetMyPasswordCta: 'Reset My Password Instead',
        createNewPasskeyCta: 'Continue',
        errorPasskeyMaxAttempts: 'You have exceeded the maximum number of passkey reset attempts. Please try again later.'
    };

    return resources[label];
}
